import Entity from 'lib/Entity';

function stringify(value: any) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return String(value);
}

export default class LinkPreview extends Entity {
  parse(response: Object & { imageUrl?: any }) {
    const data: any = Object.assign({}, response);

    if (response.imageUrl) {
      data['image'] = response.imageUrl;
    }

    return data;
  }

  getTitle(): string | undefined | null {
    return stringify(this.get('title'));
  }

  getDescription(): string | undefined | null {
    return stringify(this.get('description'));
  }

  getImageUrl(): string | undefined | null {
    return stringify(this.get('image'));
  }

  getImageWidth(): string | undefined | null {
    return stringify(this.get('image_width'));
  }

  getImageHeight(): string | undefined | null {
    return stringify(this.get('image_height'));
  }

  getRichContentType(): string | undefined | null {
    return stringify(this.get('rich_content_type'));
  }

  getRichContentUrl(): string | undefined | null {
    return stringify(this.get('rich_content_url'));
  }

  getUrl(): string | undefined | null {
    return stringify(this.get('url'));
  }

  toGraphQL() {
    return {
      title: this.getTitle(),
      description: this.getDescription(),
      url: this.getUrl(),
      imageUrl: this.getImageUrl(),
    };
  }
}
